// extracted by mini-css-extract-plugin
export default {"card":"card_card__e3Efj","cardP":"card_cardP__sJWUs"};